import * as React from "react";
import { TitleBar, WidgetWrapper } from "uxp/components";
import { isNone } from "../../../../util";
import { IUIPropertyDefinitionMap, IWidgetTemplateProps, registerCardTemplate } from "../../../common/common";
import { generateIconProp, generateIconPropAsSting } from "../../../common/icon-selector/IconEditor";
import { SelectableItem, selectUIProps } from "../../../common/SelectableItem";
import { HTMLCodeProperty } from "../../../common/ui-props/HTMLCodeProperty";
import { SimpleTextProperty } from "../../../common/ui-props/SimpleTextProperty";
import { IContextData, useInitialContextData } from "../../../../hooks/useContextData";


export const DUMMY_HTML = `<div class="contact">
        <hr color="#000" width="20%">
            <p align="center"><font color="#017bf5" size="5.5">Design anything with HTML</font></p>
        <hr color="#000" width="20%">
        
        <form name="f1" id="contact-form" style="border: 1px solid gray; margin-top: 10% ">
            <table align="center" cellpadding="1" cellspacing="2" height="200">
                <tr>
                    <td>
                        <input type="text" name="first_name" placeholder="First Name" required="required" />
                    </td>
                    <td>
                        <input type="text" name="Last_name" placeholder="Last Name" required="required" />
                    </td>
                </tr>
                <tr>
                    <td><input type="email" name="email" placeholder="Email" required="required" /></td>
                    <td><input type="text" name="subject" placeholder="Subject" required="required" /></td>
                </tr>
                <tr>
                    <th colspan="2">
                        <textarea placeholder="Enter Message" rows="3" required=""></textarea>
                    </th>
                </tr>
                <tr>
                    <th colspan="2">
                        <input type="submit" name="contact-submit" value="SEND">
                    </th>
                </tr>
            </table>
        </form>
    </div>
`


const XPR: React.FunctionComponent<IWidgetTemplateProps> = props => {

    let uiProps = Object.keys(props?.uiProps).length > 0 ? props?.uiProps : { html: DUMMY_HTML };

    console.log('some ui', uiProps)

    const XPRProps: IUIPropertyDefinitionMap = {
        'html': HTMLCodeProperty('HTML Code', uiProps?.html),
    }

    const [loading, setLoading] = React.useState(false)
    let [contextData, setContextData] = React.useState<IContextData>({})

    const { isLoading, initialContextData } = useInitialContextData(props)

    React.useEffect(() => {
        setLoading(isLoading)
        setContextData(prev => ({ ...prev, ...initialContextData }))
    }, [isLoading, initialContextData])

    return <WidgetWrapper >

        <SelectableItem
            designer={props.designer}
            props={selectUIProps(uiProps, XPRProps, 'html')}
            contextData={contextData}
        >
            <div style={{ flex: 1 }} dangerouslySetInnerHTML={{ __html: uiProps?.html }} />
        </SelectableItem>

    </WidgetWrapper>
}


registerCardTemplate({
    id: 'html-card',
    name: "HTML Card",
    description: 'A widget to show html content',
    template: XPR,
    icon: generateIconProp('html5'),
    complexity: 'medium',
});